module.exports = __webpack_public_path__ + "img/reward-coin-icon.21edbff5.svg";